import React from 'react';

export const GeometricBackground = ({ className = '', showAyatAlKursi = false }) => {
    return (
        <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}>
            {/* Ayat al-Kursi Background Pattern - Golden Arabic text like the Kaaba covering */}
            {showAyatAlKursi && (
                <div className="absolute inset-0 flex items-center justify-center opacity-[0.07]">
                    <div className="font-arabic text-secondary text-[8rem] md:text-[12rem] leading-relaxed text-center select-none" dir="rtl" style={{ writingMode: 'horizontal-tb' }}>
                        <div className="whitespace-nowrap">
                            اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ
                        </div>
                        <div className="whitespace-nowrap">
                            لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ
                        </div>
                        <div className="whitespace-nowrap">
                            لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ
                        </div>
                    </div>
                </div>
            )}
            
            {/* Subtle gold line accents */}
            <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-secondary/30 to-transparent" />
            <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-secondary/30 to-transparent" />
        </div>
    );
};
